module.exports = __webpack_public_path__ + "img/subscription.1daafcc7.svg";